module.exports = __webpack_public_path__ + "media/typy/przyczepy@3x-935cf1f2.svg";